const DEFAULT_FILENAME = 'export.csv';

const stepStripHtml = (state, ch) => {
  if (state.inTag) {
    return ch === '>' ? { out: state.out, inTag: false } : state;
  }
  if (ch === '<') {
    return { out: state.out, inTag: true };
  }
  return { out: state.out + ch, inTag: false };
};

/** Linear-time strip of simple `<...>` tags (avoids ReDoS-prone regex). */
const stripHtml = (value) => {
  const initial = { out: '', inTag: false };
  const final = Array.from(String(value)).reduce(stepStripHtml, initial);
  return final.out;
};

const stringifyCellValue = (value) => {
  try {
    return JSON.stringify(value);
  } catch {
    return String(value);
  }
};

const CELL_NORMALIZERS = {
  string: stripHtml,
  number: String,
  boolean: String,
  object: stringifyCellValue,
};

const normalizeCell = (value) => {
  if (value == null) {
    return '';
  }
  const normalizer = CELL_NORMALIZERS[typeof value];
  return normalizer ? normalizer(value) : stringifyCellValue(value);
};

const escapeCsvCell = (raw) => {
  const value = normalizeCell(raw);
  const needsQuotes = /[",\n\r]/.test(value);
  const escaped = value.replaceAll('"', '""');
  return needsQuotes ? `"${escaped}"` : escaped;
};

/** Same CSV serialization as {@link downloadCsv} (for embedding in zip archives). */
export const buildCsvString = (headers, rows) => {
  const headerLine = headers.map(escapeCsvCell).join(',');
  const lines = rows.map((row) => row.map(escapeCsvCell).join(','));
  return [headerLine, ...lines].join('\r\n');
};

/**
 * @param {string} filename
 * @param {Blob} blob
 * @param {string} fallbackName
 */
const triggerBlobDownload = (filename, blob, fallbackName) => {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename || fallbackName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
};

export const downloadCsv = ({ filename, headers, rows }) => {
  const csv = buildCsvString(headers, rows);
  triggerBlobDownload(filename, new Blob([csv], { type: 'text/csv;charset=utf-8' }), DEFAULT_FILENAME);
};

/**
 * Triggers a browser download for an arbitrary binary blob (e.g. zip).
 * @param {string} filename
 * @param {Blob} blob
 */
export const downloadBlob = (filename, blob) => {
  triggerBlobDownload(filename, blob, 'download.bin');
};

